// oxlint-disable-next-line cian-eslint-compat/no-extraneous-dependencies
import { EPageTypes, EPlatformTypes, handleDynamicCalltracking } from '@cian/frontend-newbuilding-call-component';
import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { TDeviceType } from '@cian/ui-kit/types';
import { EDeviceType } from '../../types/deviceType';

interface IComagicProps {
  comagicId: number | null;
  placeType: string;
  announcementId: number;
  deviceType?: TDeviceType;
  isMap?: boolean;
}

interface IContextcProps {
  logger: ILogger;
  httpApi: IHttpApi;
}

export const fetchComagic = async (
  { comagicId, placeType, announcementId, isMap, deviceType }: IComagicProps,
  { logger, httpApi }: IContextcProps,
): Promise<string | null> => {
  if (comagicId) {
    const additionalParams = isMap
      ? {
          platformType: deviceType === EDeviceType.Desktop ? EPlatformTypes.WebDesktop : EPlatformTypes.WebMobile,
          pageType: EPageTypes.Map,
        }
      : { platformType: EPlatformTypes.WebMobile, pageType: EPageTypes.OfferList };

    const dynamicCalltracking = await handleDynamicCalltracking({
      blockId: comagicId,
      httpApi,
      logger,
      placeType,
      announcementId,
      ...additionalParams,
    });

    if (dynamicCalltracking && dynamicCalltracking.notFormattedPhone) {
      return `+${dynamicCalltracking.notFormattedPhone}`;
    }
  }

  return null;
};
